module.exports = "<p>\n</p>\n<div class=\"row\">\n    <div class=\"col-md-12 col-sm-12 col-xs-12 text-center\">\n        <div class=\"preselect-loader\" *ngIf=\"loader\" style=\"margin-top: 50%;\">\n            <div class=\"spinner\">\n                <div class=\"bounce1\"></div>\n                <div class=\"bounce2\"></div>\n                <div class=\"bounce3\"></div>\n            </div>\n        </div>\n  </div>  \n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cqm-ns/auth-sec/auth-sec.component.html
// module id = ./src/app/modules/cqm-ns/auth-sec/auth-sec.component.html
// module chunks = main